/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Getsyearlyreport2Inputs */

const de__field_getsyearlyreport2 = /** @type {(inputs: _Field_Getsyearlyreport2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soll Jahresbericht erhalten`)
};

/**

* @param {_Field_Getsyearlyreport2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_getsyearlyreport2 = /** @type {((inputs?: _Field_Getsyearlyreport2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Getsyearlyreport2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_getsyearlyreport2(inputs)
});
export { _field_getsyearlyreport2 as "_field_getsYearlyReport" }